export default __webpack_public_path__ + "static/media/Pyramide-besoins_pro_n3_appartenance-horizontale.8108763d.svg";